<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 2.goodsTitle-container-start -->
    <!-- <goods-title></goods-title> -->
    <tabbar :tabbarIndex="0"></tabbar>
    <!-- <img width="100%" src="../../images/head.png"> -->
    <img
      width="100%"
      :src="web_top_imgurl"
      @click="link(web_top_linkurl)"
      alt=""
    />
    <marquee behavior="scroll" class="tishi">{{ web_rolling_notice }}</marquee>
    <div class="person">
        <div class="kefu"
          @click="clicked_OnlineService()"
          style="cursor: pointer;">
        <img
          style="margin-top: 30px; text-align: center"
          src="../../images/kefu.png"
        />
        <div
          style="
            height: 30px;
            line-height: 30px;
            background-color: rgb(204, 127, 12);
            color: #fff;
            margin-top: 10px;
          "
        >
          在线客服
        </div>
        <div
          style="
            height: 30px;
            line-height: 30px;
            background-color: rgb(204, 127, 12);
            color: #fff;
            margin-top: 10px;
          "
        >
          售后处理
        </div>
      </div>
    </div>
    <!-- 2.goodsTitle-container-end -->

    <!-- 3.goodsMain-container-start -->
    <div class="goodsMain">
      <div class="show borderShadow">
        <!-- <el-button type="text" @click="dialogVisible = true" >点击打开 Dialog</el-button> -->

        <el-dialog
          v-if="isdue != 1 && GGList.length > 0"
          :close-on-click-modal="close_modal"
          :visible.sync="dialogVisible"
          :modal="false"
          width="20%"
          :before-close="handleClose"
          :showClose="false"
          :center="true"
          style="margin-top: 140px;"
        >
          <div class="righttip">
            
            <div
              :class="index > 1 ? 'item hands' : 'item2 hands'"
              v-for="(item, index) of GGList"
              :key="index"
             >
            <!-- <div class="tip"> {{ item.notice_title || "暂无标题" }}</div> -->
              <span>{{ index + 1 }}.</span>&nbsp;&nbsp;&nbsp;&nbsp;{{ item.notice_title || "暂无标题" }}<br>
              {{ item.notice_info || "暂无内容" }}
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false"
              ><span class="read">已阅读</span></el-button
            >
          </span>
        </el-dialog>
      </div>
      <div class="card borderShadow">
        <h4 class="title">{{ TCInfo.setmeal_name || "暂无名称" }}</h4>
        <div class="left">
          <img v-if="TCInfo.pc_img" :src="TCInfo.pc_img" class="img" />
          <img v-else src="../../images/task1.png" class="img" />
        </div>
        <div class="middle">
          <div class="top">套餐编号：{{ TCInfo.setmeal_code }}</div>
          <div class="middle tishi">提示：</div>
          <div class="middle oneLine">
            您好，您选择的套餐是-{{
              TCInfo.setmeal_name || "暂无名称"
            }}，以下是该套餐的商品。
          </div>
          <div class="bottom twoLine">
            如有疑问欢迎来电咨询:
            <span v-for="(item, index) of web_tel" :key="index"
              >{{ item }} {{ index + 1 == web_tel.length ? "" : "、" }}</span
            >
          </div>
          <button @click="fanhui" class="fanhui">返回</button>
        </div>
        <!-- <div class="right borderShadow" v-if="GGList.length > 0">
          <div class="tip">公告</div>
          <div
            class="item hands"
            @click="watchGGDetail(item)"
            v-for="(item, index) of GGList"
            :key="index"
          >
            <span>{{ index + 1 }}.</span>{{ item.notice_title || "暂无标题" }}
          </div>
        </div> -->
      </div>

       <div class="tip">以下是该套餐内配产品详情展示</div>
      <div class="goods borderShadow" style="justify-content: center;"   v-if="TCInfo.setmeal_info_pc==null">
      
       <!-- <div
          @click="watchGoodsDetail(item)"
          class="item borderShadow hands"
          v-for="(item, index) of goodsList"
          :key="index"
        >
          <div class="photo">
            <img :src="item.pc_img" class="img" />
          </div>
          <div class="name">{{ item.goods_name || "暂无商品名称" }}</div>
          <div class="number">数量:{{ item.amount || "0" }}</div>
        </div> -->
      </div>
      <div class="goods borderShadow" v-html="TCInfo.setmeal_info_pc"  v-if="TCInfo.setmeal_info_pc!=null" >
       {{TCInfo.setmeal_info_pc}}
         <!-- <div  v-for="(item, index) of goodsList" class="item borderShadow hands" style="width:350px;"
          :key="index"  >
          商品编号：{{ item.goods_code || "暂无商品编号" }}<br>
          商品名称：{{ item.goods_name || "暂无商品名称" }}<br>
          数量：{{ item.amount || "0" }}<br>
          体积： {{ item.volume || "暂无商品体积" }}<br>
          重量：{{ item.weight || "0" }}
          </div>-->
       
        </div> 


      <!-- </div> -->
      <!-- <h4 class="goodstitle">套餐内配</h4>
        <table border="1" cellspacing="0" class="shop">
          <tr>
            <td>商品图片</td>
            <td>商品编号</td>
            <td>商品名称</td>
            <td>商品数量</td>
          </tr>
          <tr  v-for="(item, index) of goodsList"
          :key="index">
        
            <td> 
              <div class="photo">
                <img :src="item.pc_img" class="img" />11
              </div>
           </td>
         <td>{{item.goods_code || '暂无商品编号'}}</td>
            <td> 
              <div class="name">{{ item.goods_name || "暂无商品名称" }}</div>
            </td>
           <td><div class="number">{{ item.amount || "0" }}</div></td>
          </tr>
           
        </table> -->

      <!-- </div> -->
      <div class="duihuan">
        <button @click="duihuan()" id="dui-btn">立即兑换</button>
      </div>
    </div>
    <!-- 3.goodsMain-container-end -->

    <!-- 4.goodsFooter-container-start -->
    <!-- <goods-footer></goods-footer> -->
    <c-footer></c-footer>
    <!-- 4.goodsFooter-container-end -->

    <success-cover :isShow="isShow" :showContent="showContent"></success-cover>
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import tabbar from "../../components/tabbar/tabbar";
import footer from "../../components/footer/footer";
// import goodsTitle from "../../components/goodsTitle/goodsTitle";
// import goodsFooter from "../../components/goodsFooter/goodsFooter";
import successCover from "../../components/successCover/successCover";
import {
  TCInterGGListRequest,
  goodsListlRequest,
  TCDetailRequest,
} from "../../public/js/service";
var interval;

export default {
  data() {
    // 1.data
    return {
      close_modal: false,
      dialogVisible: true,
      isdue: 0, // 1.10.当前卡是否过期了？1表示过期
      web_rolling_notice: "", //滚动公告
      web_top_imgurl: "", // pc顶部图片链接
      web_top_linkurl: "", // pc顶部跳转链接
      currentPageInfo: {}, // 1.1.currentPageInfo
      setmealId: "", // 1.2.套餐id
      token: "", // 1.3.token
      sysId: "", // 1.4.sysId
      cardTypeId: "", // 1.5.卡型id
      card_type:'',//1.5.1卡型
      TCInfo: {}, // 1.6.套餐信息
      web_tel: "", // 1.7.客服电话
      goodsList: [], // 1.8.套餐下商品列表
      citys_path: "", // 1.9.地址的请求路径
      country: [], // 1.10.全国数据
      provinceIndex: 0, // 1.11.选择的省份位置
      city: [], // 1.12.城市数据
      cityIndex: 0, // 1.13.选择的城市位置
      area: [], // 1.14.区域数据
      areaIndex: 0, // 1.15.选择的城市位置

      consignee: "", // 1.16.收件人姓名
      consigneePhone: "", // 1.17.收件人电话
      consigneeAddr: "", // 1.18.收件人详细地址
      isShow: false, // 1.19.兑换成功遮罩层
      submitTimer: true, // 1.20.提交按钮防止连点

      consigneePhone2: "", // 1.21.备用手机号
      workNumber: "", // 1.22.工号

      GGList: [], // 1.23.套餐公告列表
      showContent: "兑换成功", // 1.24.兑换成功提示语

      xPos: 0,
      yPos: 0,
      xin: true,
      yin: true,
      step: 1,
      delay: 18,
      height: 0,
      Hoffset: 0,
      Woffset: 0,
      yon: 0,
      xon: 0,
      pause: true,
      thedivShow: true,
    };
  },

  components: {
    // 2.components
    // goodsTitle,
    // goodsFooter,
    tabbar,
    cFooter: footer,
    successCover,
  },

  methods: {
    clicked_OnlineService() {
      var url = localStorage.web_online_service;
      if (url && url != "" && url != "#") {
        url =
          url.toLowerCase().indexOf("http:") > -1 ||
          url.toLowerCase().indexOf("https:") > -1
            ? url
            : "http://" + url;
        var tempwindow = window.open("");
        tempwindow.location = url;
      }
    },
    fanhui() {
      this.$router.go(-1);
    },
    // 3.methods
    getTCDetail() {
      // 3.1.获取套餐->获取套餐详情
      let data={}
      if(this.card_type==4){
        data = {
          cardTypeId: this.cardTypeId,
          setmealId: this.setmealId,
          sysId: this.sysId,
          isLoadMaxQTY:1
        };
      }else{
        data = {
          cardTypeId: this.cardTypeId,
          setmealId: this.setmealId,
          sysId: this.sysId
        };
      }

      TCDetailRequest(data).then((res) => {
        if (res) {
          this.TCInfo = res.data[0];
          if(this.TCInfo.is_deal!=0||this.TCInfo.available_qty<=0&&this.card_type==4){
            this.$notify({
              title: "提示",
              message: '不可兑换',
            });
            document.querySelector('#dui-btn').style.backgroundColor='grey'
          }
          console.log(this.TCInfo.setmeal_info_pc);
          this.getGoodsInfo();
          if (this.TCInfo.is_web == 0) {
            this.$notify({
              title: "提示",
              message: this.TCInfo.web_warn,
            });
          }
        }
      });
    },
    duihuan() {

      if(this.TCInfo.is_deal!=0||this.TCInfo.available_qty<=0&&this.card_type==4){
        return;
      }

      let obj = {
        token: this.token,
        setmealId: this.TCInfo.setmeal_id,
        cardTypeId: this.cardTypeId,
      };
      console.log(333);
      console.log(this.TCInfo.setmeal_id);
      console.log(this.cardTypeId);
      this.$router.push(
        "/address?obj=" + encodeURIComponent(JSON.stringify(obj))
      );
    },
    getGoodsInfo() {
      // 3.2.获取套餐->获取套餐商品列表
      let data = {
        setmealId: this.setmealId,
        sysId: this.sysId,
      };

      goodsListlRequest(data).then((res) => {
        if (res) {
          if (res.data.length == 1) {
            for (var i = 0; i < res.data.length; i++) {
              var reg = res.data[i].pc_img.split(",");
              res.data[i].pc_img = reg[0];
            }
          }

          this.goodsList = res.data;
        }
      });
    },

    watchGoodsDetail(item) {
      // 3.3.查看商品详情
      let obj = {
        setmealId: this.setmealId,
        token: this.token,
        goodId: item.goods_id,
      };

      this.$router.push(
        "/goodsDetail?obj=" + encodeURIComponent(JSON.stringify(obj))
      );
    },

    // getaddress() {
    //   // 3.4.缓存中读取地址信息
    //   this.country = JSON.parse(localStorage.country);
    // },

    submitBefore() {
      // 3.5.提交之前的验证
      let verifacationResult = this.verifacation();
      if (verifacationResult) {
        if (this.submitTimer) {
          this.submitRequest();
        }
      }
    },
    getGGList() {
      // 3.8.套餐->公告列表
      let data = {
        setmealId: this.setmealId,
        sysId: this.sysId,
        pageNo: -1,
        pageSize: -1,
      };

      TCInterGGListRequest(data).then((res) => {
        console.log("res");
        console.log(res);
        if (res) {
          this.GGList = res.rows;
          console.log("this.GGList");
          console.log(this.GGList);
        }
      });
    },

    watchGGDetail(item) {
      // 3.9.查看公告详情
      let obj = {
        noticeId: item.notice_id,
        token: this.token,
      };

      this.$router.push(
        "/ggDetail?type=1&obj=" + encodeURIComponent(JSON.stringify(obj))
      );
    },

    openLoading() {
      // 3.10.打开加载遮罩层
      this.loadingInstance = this.$loading.service({
        fullscreen: true,
        lock: true,
      });
    },

    closeLoading() {
      // 3.11.关闭遮罩层
      this.loadingInstance.close();
    },

    changePos() {
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      if (null != this.$refs.thediv) {
        this.Hoffset = this.$refs.thediv.offsetHeight; //获取元素高度
        this.Woffset = this.$refs.thediv.offsetWidth;
      }

      this.xPos = width - this.Woffset;
      this.yPos = height / 2 - this.Hoffset / 2;

      if (null != this.$refs.thediv) {
        // 滚动部分跟随屏幕滚动
        this.$refs.thediv.style.left =
          this.xPos +
          document.body.scrollLeft +
          document.documentElement.scrollLeft +
          "px";
        this.$refs.thediv.style.top =
          this.yPos +
          document.body.scrollTop +
          document.documentElement.scrollTop +
          "px";
      }

      // 滚动部分不随屏幕滚动
      //   this.$refs.thediv.style.left =
      //     this.xPos + document.body.scrollLeft + "px";
      //   this.$refs.thediv.style.top = this.yPos + document.body.scrollTop + "px";

      //   if (this.yon) {
      //     this.yPos = this.yPos + this.step;
      //   } else {
      //     this.yPos = this.yPos - this.step;
      //   }
      //   if (this.yPos < 0) {
      //     this.yon = 1;
      //     this.yPos = 0;
      //   }
      //   if (this.yPos >= height - this.Hoffset) {
      //     this.yon = 0;
      //     this.yPos = height - this.Hoffset;
      //   }

      //   if (this.xon) {
      //     this.xPos = this.xPos + this.step;
      //   } else {
      //     this.xPos = this.xPos - this.step;
      //   }
      //   if (this.xPos < 0) {
      //     this.xon = 1;
      //     this.xPos = 0;
      //   }
      //   if (this.xPos >= width - this.Woffset) {
      //     this.xon = 0;
      //     this.xPos = width - this.Woffset;
      //   }
    },
    clearFdAd() {
      clearInterval(interval);
    },
    starFdAd() {
      interval = setInterval(this.changePos, this.delay);
    },
    link(url) {
      if (url != "") {
        url =
          url.toLowerCase().indexOf("http:") > -1 ||
          url.toLowerCase().indexOf("https:") > -1
            ? url
            : "http://" + url;
        window.location = url;
      }
    },
  },

  mounted() {
    // 4.mounted
    this.sysId = localStorage.sysId || "";
    // this.citys_path = localStorage.citys_path || "";
    this.web_tel = JSON.parse(localStorage.web_tel) || "";
    this.web_rolling_notice = localStorage.web_rolling_notice || ""; //滚动公告
    this.web_top_imgurl = localStorage.web_top_imgurl || "";
    this.web_top_linkurl = localStorage.web_top_linkurl || "";

    let res = JSON.parse(decodeURIComponent(this.$route.query.obj));
    this.token = res.token;
    this.setmealId = res.setmealId;
    this.cardTypeId = res.cardTypeId;
    this.card_type=res.card_type;
    this.getTCDetail();
    // this.getaddress();
    this.getGGList();

    interval = setInterval(this.changePos, this.delay);
  },

  watch: {
    // 5.watch
    provinceIndex() {
      // 5.1.监听省份的选择变化
      this.city = this.country[this.provinceIndex].cityList;
      this.area = [];
      this.areaIndex = 0;
      this.cityIndex = 0;
    },

    cityIndex() {
      // 5.2.监听城市的选择变化
      this.area = this.city[this.cityIndex].areaList;
      this.areaIndex = 0;
    },
  },
};
</script>

<style scoped lang="scss">
@import "./goodsAddress.scss";
.read {
  background-color: rgb(175, 37, 37);
  color: #fff;
  // margin-right: 43%;
  padding: 5px 10px;
  cursor: pointer;
}
</style>